export const TABLE_KEY_FIELD = 'sessionId';
export const TABLE_TITLE = 'WFA Sessions';
export const TABLE_CAPTION = 'WFA Sessions table';
export const DATA_TYPE = 'sessions';
export const SELECT_SESSIONS_PROMPT = 'Select one or more sessions to update the labels';
export const ADD_LABELS_BUTTON_LABEL = 'Add label';
export const CHANGE_LABEL_VALUE_BUTTON_LABEL = 'Change label value';
export const REMOVE_LABELS_BUTTON_LABEL = 'Remove label';
